import { array, assign, number, object, omit } from "superstruct";

import { CartResponseSchema } from "./CartResponseSchema";
import { CartSectionsSchema } from "./CartSectionsSchema";
import DiscountSchema from "./DiscountSchema";

export const UpdateCartResponseSchema = assign(
    omit(CartResponseSchema, ["cart_level_discount_applications"]),
    object({
        cart_level_discount_applications: array(
            object({ amount: number(), discount_application: DiscountSchema })
        ),
        sections: CartSectionsSchema,
    })
);
